import { create } from "zustand";
import { persist } from "zustand/middleware";

const useBRSRStore = create(
  persist(
    (set) => ({
      selectedBRSR: null,
      setSelectedBRSR: (id) => set({ selectedBRSR: id }),
      reset: () => set({ selectedBRSR: null }),
    }),
    {
      name: "auth-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useBRSRStore;
